export const Appconstants = {
  loginUrl:
    'https://login.microsoftonline.com/infosystechnologies.onmicrosoft.com/oauth2/authorize?client_id=$clientid&response_type=code&scope=openid&response_mode=query&redirect_uri=$redirecturi&domain_hint=infosys.com&resource=$resource&state=12345&nonce=678910',
  // loginUrl:'https://login.microsoftonline.com/isepmpoc.onmicrosoft.com/oauth2/authorize?client_id=$clientid&response_type=code&scope=openid&response_mode=query&redirect_uri=$redirecturi&domain_hint=infosys.com&resource=$resource&state=12345&nonce=678910',
  accessToken: 'accesstoken',
  input: 'input',
  date: 'date',
  select: 'select',
  textarea: 'textarea',
  applyLeaveId: 1,
  wfhId: '10',
  inputId: 0,
  selectId: 11,
  selectIdWithKey: 39,
  textareaId: 1,
  dateId: 15,
  multiselectcheckbox: 50,
  dateId2: 16,
  checkBoxId: 5,
  type: '11',
  empNo: '684450',
  empty: '',
  isRemoteConnection: 1,
  blackBerryUser: true,
  company: 'INFSYS',
  address: 'Test',
  zero: 0,
  one: 1,
  two: 2,
  minusOne: -1,
  rdTapIT: 'rdTapIT',
  rdPeople: 'rdPeople',
  rdProject: 'rdProject',
  rdLocation: 'rdLocation',
  peopleSearch: '100',
  projectSearch: 'PRJECT',
  locationSearch: 'LCTN',
  searchData: 'searchData',
  equalTo: '=',
  cardViewId: '5',
  groupCardViewId: '28',
  leaveComponmet: '2',
  holidayCalenderComponmet: '1',
  dynamicFormComponentId: 'T',
  peopleSearchComponentId: '100',
  projectSearchComponentId: 'PRJECT',
  locationSearchComponentId: 'LCTN',
  faqDynamic: '1',
  accessTokenNull: null,
  accessTokenSet: 'set',
  unAuthorized: 401,
  tapIt: '/tapit',
  ttd: '/ttd',
  info: '/info',
  circle: '/circle',
  ignoreCase: 'i',
  faqRoutingPath: '/app-faq',
  faqRoutingNavigate: 'faq/app-faq',
  tapitNavigate: '/tapit',
  homeRouting: '/app-home',
  hideSearchArea: 'hide',
  showSearchArea: 'show',
  flipHide: 'sp2_flipcard hide',
  flipShow: 'back show',
  appendString: '_',
  peopleSearchText: 'People search',
  projectSearchText: 'Project search',
  txtEmpNo: 'EmpNo',
  searchedEmpNO: '{3}',
  locationTitle: 'Location search',
  noEmployeeNumber: 'Kindly enter employee number/name to search',
  noData: 'Data Not Available',
  emptyData: null,
  typeAhead: 'tapitemphub/api/TapIT/TypeAhead/both',
  peopleSearchUrl: 'ids/api/EmployeeDetails/GetFilteredEmployeeDetailsFAST?txtEmpNameOrtxtEmpno=',
  projectSearchUrl: 'hivesrchres/api/HiveSearchResult/FnGetKeywordSearchResultsHiveMobile?strSearchKey=',
  projectKeywordSearchUrl: '&batchCount=0&FilterValue=null',
  locationSearchUrl: 'ids/api/EmployeeDetails/GetOfficesSearch?txtestname=',
  inbayInfoItemsUrl: 'inbaytransactions/InformationItem',
  actionDetailsUrl: 'inbaytransactions/ActionItemForWeb',
  approverDetailsUrl: 'inbaytransactions/ApprovalItemForWeb',
  formDetailsUrl: 'tapitemphub/api/TapIT/',
  approvalRemarks: '{1}',
  approvalId: '{2}',
  undefined: undefined,
  tapItQuery: 'Q',
  attendanceHoursQuarterly: 54,
  attendanceHoursYearly: 28,
  fields: 'fields',
  dependentDetailsId: '1160',
  true: true,
  empHubProfilePicUrl: 'tapitemphub/api/TapIT/FetchProfilePicture',
  wfhPath: 'assets/json/wfhDetails.json',
  dependentDetailsUrl: 'api/EmployeeDependentInfo/GetDependentDetails?IsMobile=true',
  logout: 'app-logout',
  accessTokenNullStr: 'null',
  success: 'Success',
  accessTokenUrl: '',
  inbayDeltionUrl: 'inbaytransactions/ActionItemForWeb',
  peopleSearchUrlSwagger: 'api/EmployeeDetails/GetFilteredEmployeeDetailsFAST?txtEmpNameOrtxtEmpno=',
  projectSearchUrlSwagger: 'api/HiveSearchResult/FnGetKeywordSearchResultsHiveMobile?strSearchKey=',
  locationSearchUrlSwagger: 'api/EmployeeDetails/GetOfficesSearch?txtestname=',
  typeAheadSwagger: 'api/TapIT/GetTypeAhead?Keyword=both',
  formDetailsUrlSwagger: 'api/TapIT/GetSearchActivityUrl?ID=',
  empHubProfilePicUrlSwagger: 'api/TapIT/FetchProfilePicture',
  inbayDeltionUrlSwagger: 'InbayInformation/DeleteItem/',
  postLeaveswagger: 'api/UserActions/PostApplyEarnedLeave',
  getleaveSwagegr: '',

  resource: 'https://itgatewaytst.infosys.com/',
  clientId: 'feacf2e9-234e-4eef-85fe-534b0551bdd3',
  wallRouting: '/app-wall/app-home',
  errorRouting: '/app-error',
  loginRouting: '/app-login',
  znch: '/zh-cn',
  typeAheadSwaggerLauncher: 'api/TapIT/GetTapitLaunchersDetails?strSelectedFunction',
  launches: 'Launches',
  work: '/app-wall/work',
  ahd: '/app-wall/ahd',
  approved: 'approved',
  rejected: 'rejected',
  redirect: 'redirected',
  forward: 'forwarded',
  reportAProblem: 'http://isvgenwt01/ReportProblemV2/Main.aspx?AppName=EmpHub',
  batchCount: ',0,',
  dateString: 'date',
  monthString: 'month',
  yearString: 'year',
  genModelPath: 'assets/json/genModel.json',
  genModelId: '100000',
  routingLogin: 'login',
  routingWall: 'wall',
  get: 'get',
  post: 'post',
  both: 'both',
  inbayinfo: 'inbayinfo',
  inbayaction: 'inbayaction',
  inbayapprover: 'inbayapprover',
  peoplesearch: 'peoplesearch',
  projectsearch: 'projectsearch',
  locationsearch: 'locationsearch',
  profilepicservice: 'profilepicservice',
  valuefortypeahead: 'valuefortypeahead',
  formdetails: 'formdetails',
  dependentdetailsurl: 'dependentdetailsurl',
  tapitswaggerlauncher: 'tapitswaggerlauncher',
  projectcodedetails: 'projectcodedetails',
  inbaydelete: 'inbaydelete',
  yearly: 'Yearly',
  accessTokenBaseUrl: 'access-token',
  javaServiceUsingName: 'ehub/v1/doServiceCallusingName/',
  javaServiceUsingUrl: 'ehub/v1/doServiceCallusingUrl/',
  chatbotEndPoint: '#/chat-bot?bot=employeebot',
  quarterly: 'Quaterly',
  monthly: 'Monthly',
  chatBotclick: 'ChatBotclick',
  chatBotComponent: 'ChatBotComponent',
  chatBotScroll: 'ChatBotScroll',
  chatBotKeypress: 'ChatBotKeypress',
  chatBot: 'ChatBot',
  errorclick: 'Errorclick',
  usaCountry: 'USA',
  OnsiteUSResidential: 'US ResidentailAddress',
  errorComponent: 'ErrorComponent',
  errorScroll: 'ErrorScroll',
  errorKeypress: 'ErrorKeypress',
  error: 'Error',
  footerclick: 'Footerclick',
  footerComponent: 'FooterComponent',
  footerScroll: 'FooterScroll',
  footerKeypress: 'FooterKeypress',
  footer: 'Footer',
  headerclick: 'Headerclick',
  headerComponent: 'HeaderComponent',
  headerScroll: 'HeaderScroll',
  headerKeypress: 'HeaderKeypress',
  header: 'Header',
  homeclick: 'Homeclick',
  homeComponent: 'HomeComponent',
  homeScroll: 'HomeScroll',
  homeKeypress: 'HomeKeypress',
  home: 'Home',
  oneClickAHDclick: 'OneClickAHDclick',
  oneClickAHDComponent: 'OneClickAHDComponent',
  oneClickAHDScroll: 'OneClickAHDScroll',
  oneClickAHDKeypress: 'OneClickAHDKeypress',
  oneClickAHD: 'OneClickAHD',
  workclick: 'Workclick',
  workComponent: 'WorkComponent',
  workScroll: 'WorkScroll',
  workKeypress: 'WorkKeypress',
  workid: 'Work',
  navbarclick: 'Navbarclick',
  navbarComponent: 'NavbarComponent',
  navbarScroll: 'NavbarScroll',
  navbarKeypress: 'NavbarKeypress',
  navbar: 'Navbar',
  detailedViewclick: 'DetailedViewclick',
  detailedViewComponent: 'DetailedViewComponent',
  detailedViewScroll: 'DetailedViewScroll',
  detailedViewKeypress: 'DetailedViewKeypress',
  detailedView: 'DetailedView',
  emptyClick: 'EmptyClick',
  emptyScroll: 'EmptyScroll',
  emptyKeypress: 'EmptyKeypress',
  emptyComponent: 'EmptyComponent',
  genmodelclick: 'Genmodelclick',
  genmodelComponent: 'GenmodelComponent',
  genmodelScroll: 'GenmodelScroll',
  genmodelKeypress: 'GenmodelKeypress',
  genmodel: 'Genmodel',
  groupCardViewclick: 'GroupCardViewclick',
  groupCardViewComponent: 'GroupCardViewComponent',
  groupCardViewScroll: 'GroupCardViewScroll',
  groupCardViewKeypress: 'GroupCardViewKeypress',
  groupCardView: 'GroupCardView',
  locationSearchViewclick: 'LocationSearchViewclick',
  locationSearchViewComponent: 'LocationSearchViewComponent',
  locationSearchViewScroll: 'LocationSearchViewScroll',
  locationSearchViewKeypress: 'LocationSearchViewKeypress',
  locationSearchView: 'LocationSearchView',
  peopleSearchclick: 'PeopleSearchclick',
  peopleSearchComponent: 'PeopleSearchComponent',
  peopleSearchScroll: 'PeopleSearchScroll',
  peopleSearchKeypress: 'PeopleSearchKeypress',
  peopleSearchid: 'PeopleSearch',
  projectDetails: 'ProjectDetails',
  projectDetailsComponent: 'ProjectDetailsComponent',
  projectDetailsScroll: '',
  projectDetailsKeypress: 'ProjectDetailsKeypress',
  tableView: 'TableView',
  tableViewclick: 'TableViewclick',
  tableViewComponent: 'TableViewComponent',
  tableViewScroll: 'TableViewScrol',
  tableViewKeypress: 'TableViewKeypress',
  dynamicFormclick: 'DynamicFormclick',
  dynamicFormComponent: 'DynamicFormComponent',
  dynamicFormScroll: '',
  dynamicFormKeypress: 'DynamicFormKeypress',
  dynamicForm: 'DynamicForm',
  tapitclick: 'Tapitclick',
  tapitComponent: 'TapitComponent',
  tapitScroll: 'TapitScroll',
  tapitKeypress: 'TapitKeypress',
  wallclick: 'wallclick',
  wallcomponent: 'wallcomponent',
  wallcompKeypress: 'WallcompKeypress',
  wallcompScroll: 'WallcompScroll',
  wall: 'Wall',
  tapit: 'Tapit',
  people: 'People',
  contactSearchclick: 'ContactSearchclick',
  contactSearchComponent: 'ContactSearchComponent',
  contactSearchScroll: 'ContactSearchScroll',
  contactSearchKeypress: 'ContactSearchKeypress',
  contactSearch: 'ContactSearch',
  infoitemview: 'Infoitemview',
  infoitemviewComponent: 'InfoitemviewComponent',
  infoitemviewScroll: 'InfoitemviewScroll',
  infoitemviewKeypress: 'InfoitemviewKeypress',
  infoitemviewid: 'Infoitemviewid',
  todoListclick: 'TodoListclick',
  todoListComponent: 'TodoListComponent',
  todoListScroll: 'TodoListScroll',
  todoList: 'TodoList',
  todoListKeypress: 'TodoListKeypress',
  myTeamclick: 'MyTeamclick',
  myTeamScroll: 'MyTeamScroll',
  myTeamKeypress: 'MyTeamKeypress',
  myTeam: 'MyTeam',
  myTeamComponentid: 'MyTeamComponent',
  empservviceclick: 'Empservviceclick',
  empservviceScroll: 'EmpservviceScroll',
  empservviceKeypress: 'EmpservviceKeypress',
  empservvice: 'Empservvice',
  empservviceComponentid: 'EmpservviceComponent',
  viewallservviceclick: 'Viewallservviceclick',
  viewallservviceScroll: 'ViewallservviceScroll',
  viewallservviceKeypress: 'ViewallservviceKeypress',
  viewallservvice: 'Viewall',
  viewallservviceComponentid: 'ViewallservviceComponent',
  infymeWeb: 'Infymeweb',
  app: 'APP',
  ver: 1.0,
  localTax: '26503',
  domesticTravel: '26527',
  internationalTravel: '26516',
  accommodation: '26499',
  glomoLandingConfirmation: '4102',
  profilepage: '/app-wall/profile/default',
  profilepagedefault: '/app-wall/profile/',
  viewallservices: 'viewallservices',
  imgAssets: 'assets/images/',
  profileservice: 'ProfileHarmonyServiceurl',
  profileAttendanceservice: 'AttendanceForProfile_url',
  queryParamForPrfoile: 'true',
  queryParamForAttendance: 'Yearly,T',
  timeId: 17,
  remarks: '',
  labelId: 14,
  maildId: 2,
  textBoxId: 1,
  radioId: 18,
  searchInputButton: 25,
  note: 12,
  interceptor: 'Interceptor',
  postApplyEarnedLeave: 'PostApplyEarnedLeave',
  postApplyCompOffLeave: 'PostApplyCompOffLeave',
  postApplyLeaveWithoutPay: 'PostApplyLOPLeave',
  postApplyCompOffPreApproval: 'PostApplyCompOffPreApproval',
  postApplyAdvanceLeaves: 'PostApplyAdvanceLeaves',
  aplCompOff: 'Create CompOff',
  aplAdvLeave: 'Apply Advance Leave',
  applyEL: 'Earned Leave',
  applyLOP: 'Leave Without Pay',
  applyLeaveComp: 'Comp Off',
  aplWFH: 'Apply WFH',
  applyLateStay: 'apply latestay',
  multiTravelCard: 'multi',
  aplOD: 'Apply OD',
  invalidDateRange: 'To Date should be greater than From Date',
  invalidDuration: 'Please limit the date range to 31 days!',
  noSSRecords: 'You do not have any single swipe records',
  horizontalTile: 'horizontalTile',
  largeTile: 'largeTile',
  verticalTile: 'verticalTile',
  feedbackPage: '/app-wall/feedback',
  dataprivacyPage: '/app-wall/dataPrivacy',
  shareanideaPage: '/app-wall/shareanidea',
  BankDetails: '/app-wall/BankDetails',
  publishingsBlog: '/app-wall/publishings',
  PresentAddress: 'PRESENT',
  PermanentAddress: 'PERMANENT',
  EmergencyAddress: 'EMERGENCY',
  OnsiteWorkLocationAdd: 'OnsiteWorkLocation',
  OnsiteResidentialAdd: 'OnsiteResidential',
  OnsiteEmergencyAdd: 'OnsiteEmergency',
  OnsiteWorkLocation: 'Work Location',
  OnsiteResidential: 'Residential',
  OnsiteEmergency: 'Emergency Contact',
  workLocation: 'Work Location Address Details',
  residential: 'Residential Address Details',
  emergencyContact: 'Emergency Address Details',
  OfficialKey: 'official',
  PersonalKey: 'personal',
  EducationKey: 'education',
  DataAvailable: 'Yes',
  popularIdea: 'popular',
  mostRecentIdea: 'mostrecent',
  sparshcontent: 'sparshcontent',
  peopleSearchList: 'people',
  noRSRecords: 'You dont have any Status unknown record to regualrize',
  postApplySuppLeave: 'PostApplySupplementaryLeave',
  applySuppLeave: 'Supplementary Holiday',
  edocketStatus: 'Approved',
  fifteen: 15,
  eDocketNA: 'NA',
  eDocketDlimiter: '.',
  pathCAG: '/assets/images/profile-documents.png',
  pathCNB: '/assets/images/cag-documents.png',
  pathER: '/assets/images/cag-documents.png',
  liked: 1,
  isMobile: false,
  mycirclesub: '/app-wall/submycircle',
  postApplySickLeave: 'PostApplySickLeave',
  applySickLeave: 'Sick Leave',
  mycircle: 'mycircleurl',
  sparshrecommendations: 'sparshrecommendations',
  getcomments: 'getcomments',
  postcomments: 'postcomments',
  likecomments: 'likecomments',
  sparsharticle: 'sparsharticle',
  dphistory: 'dphistory',
  dpwithdrawal: 'dpconsentwithdrawal',
  isPageLoad: true,
  eDocket: '27813',
  eDocketConsent: 'eDocketConsent',
  editUniqueId: '/app-wall/app-profile/app-edit-unique-ids',

  //SearchConstants

  appendStringForMail: '@ad.infosys.com',
  appendStringForAvailability: '@ad.infosys.com?startDate=',
  userDataUrl: '/search/indexed?contentSource=telephone&pageSize=10&source=Mobile&startIndex=0&queryText=',
  userImageUrl: '/users/profilepicture/',
  userAvailabilityUrl: '/users/availability/',
  userSkillsUrl: '/search/indexed?contentSource=allskillsfromgraph&pageSize=10&source=Mobile&startIndex=0&queryText=',
  userAwardsUrl: '/search/indexed?contentSource=afewinners&pageSize=10&source=Mobile&startIndex=0&queryText=',
  userProjectsUrl: '/search/indexed?contentSource=projectdetails&pageSize=10&source=Mobile&startIndex=0&queryText=',
  userBlogsUrl:
    '/search/indexed?contentSource=myblogs&pageSize=10&source=Mobile&startIndex=0&queryText=postauthorname:',
  userWhitePapersUrl:
    '/search/indexed?contentSource=pubportal&pageSize=50&source=Mobile&startIndex=0&queryText=pubauthormailid:',
  userWhitePapersUrl2:
    '/search/indexed?contentSource=infosysresults&pageSize=10&source=Mobile&startIndex=0&queryText=document.reference:white-papers AND ',
  userBlogsUrl2:
    '/search/indexed?contentSource=webapps&pageSize=10&source=Mobile&startIndex=0&queryText=document.reference:sparshv2 AND document.reference:Blogs AND author:',
  similarProfileUrl:
    '/search/indexed?contentSource=allskillsfromgraph&pageSize=10&source=Mobile&startIndex=0&queryText=Skills:',
  getManagerUrl: '/users/manager/',
  getDirectReportsUrl: '/users/directReports/',
  typeAheadUrl: '/search/typeahead?queryText=',
  advMessage: 'You are not eligible for advance leave',
  remarksBulkReject: 'reject',
  notEnabled: 'This feature is currently not enabled for your company in Infy Me.',
  errNoDocsCAGandCNB: "You don't have any document for the selected year.",
  errNoDocsERAndVISA: "You don't have any document for the selected category.",
  errDocNotEnabled: 'This document category not yet enabled.',
  chatBotBenifitsId: 'S0035',
  betaApp: 'InfyMeWeb',
  betaUserRouting: '/app-betauser',
  errException: 'Some error occurred. Please try again after some time.',
  errorException: 'Some error occurred. Please try again.',
  payslip: 'Payslip',
  relationID: 0,
  compensation: 'S0028',
  RSUApplicable: 'S0032',
  StockApplicable: 'S0034',
  TotalCompApplicable: 'S0060',
  TapitApply: 'Apply',
  Sparshcontentdetails: 'SparshContentDetailsComponent',
  attendanceQuarterly: 'get attendance averagehours quarterly',
  attendanceYearly: 'get attendance averagehours yearly',
  system: 'System',
  optionalHoliday: 'optionalHoliday',
  pageLoad: 'pageload',
  submit: 'Submit',
  failure: 'Failure',
  statusUnknown: 'statusUnknown',
  singleSwipe: 'Singleswipe',
  swipeRecords: 'Swiperecords',
  averageworkinghours: 'averageworkinghours',
  beta: 'betacomponent',
  banner: 'Expand banner',
  dataPrivacy: 'Data privacy load',
  reject: 'reject',
  approve: 'approve',
  delete: 'delete',
  manageService: 'ManageservicesComponent',
  takeabreak: 'TakeabreakComponent',
  profilepageview: 'Profilecomponent',
  financepageview: 'FinanceprofileComponent',
  feedbackpageview: 'Feedbackcomponent',
  singleSwipeToDo: 'Single Swipe',
  statusUnknownTodo: 'Status Unknown',
  singleSwipeID: '30_T_Regularize Single Swipe',
  statusUnknownID: '3192_T_Regularize Status Unknown',
  services: 'services',
  peopledetails: '/app-wall/people',
  peopleSearchIndex: '/app-wall/peoples-list',
  peopleorgchart: '/app-wall/orgchart',
  publishings: '/app-wall/people-publishings',
  peopleSearchDetails: 'people-search-details',
  similarProfile: 'similar profile',
  orgChart: 'org chart',
  publishing: 'publishing',
  orgChartPageId: 'orgChart',
  publishingPageId: 'publishing',
  peopleSearchIndexId: 'peopleSearchIndex',
  payslipyrDropdown: 'payslipyearDrpdownChange',
  trsID: 'trsLinkClick',
  strParentsIds: 43,
  childId: 1,
  benefitDetails: '/app-wall/app-generichome/app-benefit-details',
  benefitMetaData: '/app-wall/app-generichome/app-benefit-details/{0}',
  //benefitDetails:'/app-wall/benefit/benefitdetails',
  // benefitDetails:'/app-wall/benefit/app-benefit-details',
  benefits: '/app-wall/benefits',
  benefitsgenModelPath: 'assets/json/benefitGenModel.json',
  enrollmentpath: '/app-wall/app-generichome/app-enrollment',
  //enrollmentpath:'/app-wall/benefit/app-enrollment',
  profileEditBankDetails: '/app-wall/profile/bank-details',
  // enrollmentpath:'/app-wall/benefits/app-enrollment',
  takeABreakComponent: 'TakeABreakComponent',
  feedbackComponent: 'FeedbackComponent',
  shareAnIdeaComponent: 'shareAnIdeaComponent',
  singleSwipeComponent: 'SingleSwipeComponent',
  regularizeStatusComponent: 'RegularizeStatusComponent',
  dataPrivacyComponent: 'DataPrivacyComponent',
  manageServicesComponent: 'ManageServicesComponent',
  accept: 'Accept',
  continue: 'Continue',
  coverageForCoupe: 'SPOUSE',
  coverageForFamily: 'FAMILY',
  covergaeForSingleParent: 'CHILDREN',
  singleParent: 'SINGLE PARENT',
  parents: 'PARENTS',
  inlaws: 'IN-LAWS',
  siblings: 'SIBLINGS',
  coverageEmployee: 'SINGLE',
  couple: 'COUPLE',
  son: 'SON',
  daughter: 'DAUGHTER',
  wife: 'WIFE',
  father: 'FATHER',
  mother: 'MOTHER',
  husband: 'HUSBAND',
  brother: 'BROTHER',
  coverageplan: 'COVERAGEPLAN',
  sister: 'SISTER',
  fatherinlaw: 'FATHER-IN-LAW',
  motehrinlaw: 'MOTHER-IN-LAW',
  other: 'OTHER',
  yes: 'YES',
  no: 'NO',
  relation: 'RELATION',
  pan: 'pan',
  aadhaar: 'aadhar',
  Aadhaar: 'Aadhaar',
  nsr: 'nsr',
  passport: 'passport',
  profile: 'profile',
  adhar: 'Unique Identity Number',
  PAN: 'Unique Identity Number',
  Passport: 'Passport',
  NSR: 'National ID Details',
  editadhar: 'Edit AADHAAR',
  editPAN: 'Edit PANCard',
  editpassport: 'Edit Passport',
  editNSR: 'Edit NSR',
  requestTypeGet: 'get',
  requestTypePost: 'post',
  editLanguage: 'Edit Language',
  defaultValue: 'Select',
  addLanguageTitle: 'Add Language Details',
  editLanguageTitle: 'Edit Language Details',
  btnAdd: 'ADD',
  btnUpdate: 'UPDATE',
  language: 'Language',
  nationalSkillsRegistry: 'National Skills registry',
  requestTypeFreeze: 'freeze',
  LateStay: 'Apply LateStay',
  dependentEdit: 'Dependent Address',
  Dependent: 'Dependent',
  uniqueEdit: 'Unique Identity Number',
  Address: 'Address',
  OnsiteAddress: 'Assignment Address',
  USOnsiteAddress: 'USAssignment Address',
  Present: 'Present',
  Permanent: 'Permanent',
  Emergency: 'Emergency',
  NotApplicable: 'NA',
  EnrolmentStatus: 'ENROL',
  NID: 'National ID Details',
  bank: 'BankDetails',
  receiptStoreNav: '/app-wall/microapps/app-receiptstore',
  claimsSubmissionRoute: '/app-wall/microapps/app-claimsSubmission',
  receiptStore: 'receipt store',
  claimsSubmission: 'raise new claim',
  receiptStoreService: 'receiptstore',
  domesticNav: '/app-wall/microapps/app-domestic',
  domesticNewNav: '/app-wall/microapps/app-domestic-new',
  domestic: 'domestic',
  domesticService: 'domestic',
  accommodationcustomNav: '/app-wall/microapps/app-accommodation',
  accommodationcustom: 'accommodation',
  accommodationcustomService: 'accommodation',
  taxiNav: '/app-wall/microapps/app-taxi',
  taxi: 'taxi',
  taxiService: 'taxi',
  editDisability: 'Edit Disability',
  rdYes: 'rdYes',
  rdNo: 'rdNo',
  rdND: 'rdND',
  aadhardetails: 'Aadhar Details',
  aadhardisc: 'Aadhaar card number',
  voucherlocation: 'VOUCHERLOCATION',
  labelViewHeading: 'Heading',
  labelViewHeaderActions: 'Links',
  labelViewFields: 'fields',
  labelViewhighlightFields: 'highlightFields',
  labelViewFieldsActions: 'actions',
  suAppcatId: 10006,
  ssAppcatId: 10000,
  glomoAppcatId: 4103,
  glomoORFappCatId: '4103',
  successForTTD: 'success',
  failureForTTD: 'failure',
  applyweekendworking: 'apply weekend working',
  applyweekendworkingteam: 'apply weekend working team',
  applyodteam: 'apply od team',
  applywfhteam: 'apply wfh team',
  errorForTTD: 'error',
  glomoLandingConfAppId: '4102',
  sendbckReason: '{4}',
  appTransactionID: '{5}',
  genericTemplate: '/app-wall/app-generichome/generictemplate/{0}',
  genericTemplatewithappid: '/app-wall/app-generichome/generictemplate/{0}/{1}',
  mealVoucher: 'meal voucher',
  unifiedsearch: 'app-wall/app-search',
  glomoEndDateModification: '6350',
  strTrue: 'True',
  routeToITmetadata: 'app-wall/profile/app-income-tax-home',
  routeToITSubmission: 'app-wall/profile/app-income-tax-submission',
  proofSubmission: '1013',
  investmentproposal: '1017',
  LIC: '1018',
  dashboard: '2046',
  failed: 'failed',
  cancel: 'Cancel',
  raiseNewClaim: 'raise new claim',
  genericTempGlomo: '/app-wall/genericTempGlomo',
  smartCardQueryParam: '?city={0}&reasonForApply={1}',
  algQueryParam: '?letterType={0}',
  addbank: '/app-wall/profile/bankDetails',
  bankDetails: '/app-wall/profile/bankdetails',
  bankModule: 'Employee Bank Account',
  editBank: 'edit_bank',
  profilepageits: '/app-wall/profile/default/2',
  raceAndEthnicity: '/app-wall/app-profile/raceAndEthnicity',
  empServicespageview: 'EmpServicesComponent',
  contactSearchpageview: 'ContactSearchComponent',
  bannerpageview: 'BannerComponent',
  generichomepageview: 'GenerichomeComponent',
  myTeampageview: 'MyTeamComponent',
  myCirclepageview: 'MyCircleComponent',
  orgChartpageview: 'OrgchartComponent',
  addEditBankview: 'AddEditbankDetailsComponent',
  attendanceProfilepageview: 'AttendanceProfileComponent',
  addEditbankview: 'AddEditbankComponent',
  bankdetailspageView: 'BankdetailsComponent',
  salaryAccountpageview: 'SalaryAccountComponent',
  bankDetailspageview: 'BankDetailsComponent',
  benefitDetailpageview: 'BenefitsDetailsComponent',
  benefitpageview: 'BenefitsComponent',
  login: 'LoginComponent',
  gridviewComponent: 'GridviewComponent',
  labelviewComponent: 'LabelviewComponent',
  negativehoursComponent: 'NegativehoursComponent',
  dependentProfileComponent: 'DependentProfileComponent',
  cardViewType1Component: 'CardViewType1Component',
  cardViewType2Component: 'CardViewType2Component',
  cardViewType3Component: 'CardViewType3Component',
  cardViewType4Component: 'CardViewType4Component',
  cardViewType5Component: 'CardViewType5Component',
  cardViewType6Component: 'CardViewType6Component',
  cardViewType7Component: 'CardViewType7Component',
  cardViewType8Component: 'CardViewType8Component',
  cardViewType9Component: 'CardViewType9Component',
  cardViewType10Component: 'CardViewType10Component',
  cardViewType11Component: 'CardViewType11Component',
  cardViewType12Component: 'CardViewType12Component',
  cardViewType13Component: 'CardViewType13Component',
  labelviews1Component: 'Labelviews1Component',
  labelviews2Component: 'Labelviews2Component',
  labelviews3Component: 'Labelviews3Component',
  labelviews4Component: 'Labelviews4Component',
  inboxViewComponent: 'InboxViewComponent',
  inboxsubviewComponent: 'InboxsubviewComponent',
  cardViewActionsComponent: 'CardViewActionsComponent',
  cardViewType16Component: 'CardViewType16Component',
  genFormActionsComponent: 'GenFormActionsComponent',
  cardViewInboxViewComponent: 'CardViewInboxViewComponent',
  inboxViewType1Component: 'InboxViewType1Component',
  inboxViewType2Component: 'InboxViewType2Component',
  dashboardContentComponent: 'DashboardContentComponent',
  multipleViewsComponent: 'MultipleViewsComponent',
  perkCalculatorComponent: 'PerkCalculatorComponent',
  tabViewActionsComponent: 'TabViewActionsComponent',
  thingsToKnowComponent: 'ThingsToKnowComponent',
  claimsubmissionComponent: 'ClaimsubmissionComponent',
  insidertradingComponent: 'InsidertradingComponent',
  receiptstoreComponent: 'ReceiptstoreComponent',
  disabilitydetailsComponent: 'DisabilitydetailsComponent',
  disabilityprofileComponent: 'DisabilityprofileComponent',
  editUniqueIdsComponent: 'EditUniqueIdsComponent',
  editdependentComponent: 'EditdependentComponent',
  editlanguageComponent: 'EditlanguageComponent',
  editnationalidComponent: 'EditnationalidComponent',
  editprofileComponent: 'EditprofileComponent',
  edocketComponent: 'EdocketComponent',
  educationProfilePageId: 'EducationProfileComponent',
  enrollmentFormComponent: 'EnrollmentFormComponent',
  experienceProfilePageId: 'experienceProfileComponent',
  financeChartsPageId: 'financeChartsComponent',
  languageProfilePageId: 'languageProfileComponent',
  nationalIdProfileComponent: 'NationalIdProfileComponent',
  passportProfilePageId: 'passportProfileComponent',
  raceComponent: 'RaceComponent',
  raceAndEthnicityComponent: 'RaceAndEthnicityComponent',
  rsuProfilePageId: 'rsuProfileComponent',
  stocksprofileComponent: 'StocksprofileComponent',
  uniqueIDPageId: 'uniqueIDComponent',
  publishingsComponent: 'PublishingsComponent',
  allEmpServicesPageId: 'allEmpServicesComponent',
  holidayCalenderComponent: 'HolidayCalenderComponent',
  recommendedArticlesPageId: 'recommendedArticlesComponent',
  horizontalTileComponent: 'HorizontalTileComponent',
  largeTileComponent: 'LargeTileComponent',
  verticalTileComponent: 'VerticalTileComponent',
  sparshPageId: 'sparshComponent',
  mySubCircleComponent: 'MySubCircleComponent',
  userDetailsPageid: 'userDetailsComponent',
  userdetailslistComponent: 'UserdetailslistComponent',
  customtraveldetailsComponent: 'CustomtraveldetailsComponent',
  bankdetailsProfileComponent: 'BankdetailsProfileComponent',
  surveyComp: 'surveyComponent',
  onsiteUSAddres: 'TypeOfAddress',
  usEmergencyContact: 'Emergency Contact',
  usCountry: 'US',
  glomoAssignmentID: '7390_T_Glomo Assignment',
  countryCode: '{0}',
  claimsSubmissionMyatctivity: '/app-wall/microapps/app-claimsSubmission',
  benefit: '/app-wall/benefit/Benefits',
  thingsToDo: 'thingstodoPage',
  thingstodoSimpleSingleCard: '/app-wall/thingstodo/app-single-view/{id}',
  thingstodoSimpleBulkCard: '/app-wall/thingstodo/app-bulk-view/{id}',
  thingstodoCommonCard: '/app-wall/thingstodo/app-bulk-view/{id1}/app-common-view/{id2}',
  testMicroApp: '/app-wall/microapp/test-micro-app',
  raiseDomestic: 'domestic request',
  raiseInternational: 'international request',
  internationalNav: '/app-wall/microapps/app-international',
  international: 'international',
  internationalService: 'international',
  thingstodoCommonCardwithoutchild: '/app-wall/thingstodo/app-common-view/{id}',
  thingstodoToMicroApp: '/app-wall/app-emptyComponent',
  routeforitswithid: '/app-wall/app-insidertrading/{0}',
  routeunifiedsearchTypeahead:
    '/unitypeahead/api/typeahead?queryText={0}&source=Web&typeAheadType=services,analytics,people,skill,content,solution,proposals,telemetrydata&benefitIds={1}',
  routeunifiedsearchPeople: '/unitypeahead/api/typeahead?queryText={0}&source=Web&typeAheadType=people&benefitIds={1}',
  routeforinbayaction: '/pfapis/inbaytransactions/inbayTransactions/ActionItemForWeb',
  routeforinbayapproval: '/pfapis/inbaytransactions/inbayTransactions/ApprovalItemForWeb',
  routeforprofilepic: '/profilepic/me',
  routeforservices: '/tapit/api/TapIT/GetAllViewServices',
  routeforleftmenu: '/tapit/api/TapIT/GetMenuDetails',
  routeforgenerictemplates: '/tapit/api/TapIT/GetSectionJSON?intModuleId={0}&strQueryValue={1}&strIsInternet={2}',
  routeforbenefits: '/benefits/api/Benefits/GetBenefitDetails',
  routeforinbayapprovalInternet: '/inbaytransactions/inbaytransactions/ApprovalItemForWeb',
  routeforinbayactionInternet: '/inbaytransactions/inbaytransactions/ActionItemForWeb',
  urlForProfilePic: '',
  isMobileflag: '{5}',
  partialsuccess: 'partialsuccess',
  thingstodoinboxwithexpandandcollaps: '/app-wall/thingstodo/app-inboxwithexpandandcollaps/{id}',
  routeforIncometax: 'https://iscls2apps.ad.infosys.com/HMYPlus/aspx/incometax/HMYITDeductions.aspx',
  CardViewType13Component: 'CardViewType13Component',
  notificationsItems: 'Notifications',
  urlForPeopleToConnect: '',
  homepage: '/app-wall/app-services/viewallservices/app-generichome/generictemplate/{1}',
  Commonviewcomponent: 'common-view-component',
  Singleviewcomponent: 'Single-view-component',
  routeforwebapps: '/tapit/api/TapIT/GetWebAppsDetails',
  dpoPIA: '&requestNo={1}',
  errorMessage: 'We have a technical problem. Please try again.',
  genericTemplateHome: '/app-wall/app-home/generictemplate/{0}',
  baseUrl: 'https://infymebotft.ad.infosys.com/',
  sales360: 'Sales360Component',
  chatbotRoute: '/app-wall/chatbot',
  nationalID: '/app-wall/profile/nationalID',
  seeAll: '/app-wall/updatesfrom/other/{0}',
  empCheck: 'Employees In Verification',
  empToBe: 'Employees To Be Checked',
  details: 'Details & Checks',
  leisureBookmark: '.infosys.com/cmslifegood/api/v1/lifegood/{0}/bookmarkList?platform=Mobile',
  harmonyBankPage: 'http://iscls2apps.ad.infosys.com/HMYPlus/aspx/PayWorld/HMYPlusUXBankExample.aspx',
  oneClickAhd: 'http://isgenapps/OneclickAHD/OneClickAHD.aspx',
  shareDiscoveryContent:
    '<div id="email" style="width: 359px;background-color:white;"> <div style="height:48px;overflow:hidden"> <img alt="Infy Me" src="../hostedContents/1/$value" width="359px" height="46px" align="left"> </div> <br/> <div style="padding-left:20px;padding-right:20px;Background-color:#FFF"> <p  style="color:black"> <span style="font-weight: bold;color:black">{0}</span> wants you to read this story: </p> <p > <span style="font-weight: normal;color:black">{1}</span> </p> <p style="color:black"> InfyMe web: <span> <a href="{2}" style="font-weight: normal">{3}</a></span> </p> <p style="color:black"> InfyMe mobile: <span> <a href="{5}" style="font-weight: normal">{4}</a></span> </p> <p style="margin: 0 0 20px 0"> </p> <p style="color:black"> Happy reading!​ </p> </div> </div>',
  shareDiscoveryImage:
    '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',
  photoImage:
    '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',
  photoContent:
    '<div id="email"style="width: 359px;background-color:white;"> <div style="height:48px;overflow:hidden"> <img alt="Infy Me" src="../hostedContents/1/$value" width="359px" height="46px" align="left"> </div> <br/> <div style="padding-left:20px;padding-right:20px;Background-color:#FFF"> <p style="color:black"> <span style="font-weight: bold;color:black">{0}</span> wants you to see this photo: </p> <p> <span style="font-weight: normal;color:black">{1}</span> </p> <p style="color:black"> InfyMe web: <span> <a href="{2}" style="font-weight: normal">{3}</a></span> </p> <p style="color:black"> InfyMe mobile: <span> <a href="{5}" style="font-weight: normal">{4}</a></span> </p> <p style="margin: 0 0 20px 0"> </p> <p style="color:black"> Happy viewing!​​​​ </p> </div> </div>',
  eventImage:
    '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',
  eventContent:
    '<div id="email" style="width: 359px;background-color:white;"> <div style="height:48px;overflow:hidden"> <img alt="Infy Me" src="../hostedContents/1/$value" width="359px" height="46px" align="left"> </div> <br/> <div style="padding-left:20px;padding-right:20px;Background-color:#FFF"> <p style="color:black"> <span style="font-weight: bold;color:black">{0}</span> wants you to check out this event: </p> <p> <span style="font-weight: normal;color:black">{1}</span> </p> <p style="color:black"> InfyMe web: <span> <a href="{2}" style="font-weight: normal">{3}</a></span> </p> <p style="color:black"> InfyMe mobile: <span> <a href="{7}" style="font-weight: normal">{4}</a></span> </p> <p style="margin: 0 0 0px 0;color:black;"> Date: {5}, {6}. </p> <p style="margin: 0 0 20px 0"> </p> <p style="color:black"> See you at the event! </p> </div> </div>',
  getDCList: '/glsdetails/api/EmployeeHolidayCalendar/GetHolidayCalendarListForSearchWeb?searchString={0}&intYear={1}',
  getHolidayCalendar:
    '/glsdetails/api/EmployeeHolidayCalendar/GetHolidayCalendarDetailsForSearch?holidayCalID={0}&intYear={1}',
  barchart: 'barchart',
  InfymeTeams: 'InfymeTeams',
  jobApplyDetails: {
    name: 'Your Requests',
    guid: '',
    type: 'jobappypopup',
    heading: 'Apply for this Job',
    subtitle: 'Choose the mode of application',
    cards: [
      {
        heading: '',
        status: '',
        cardID: '1',
        highlightFields: [],
        leftalignFields: [],
        RightalignFields: [],
        fields: [],
        actions: [
          {
            input: '',
            apiType: 'GET',
            name: 'Start Filling a form',
            value: '',
            type: 'navigate',
            uitype: 'button',
            uitypevalue: '',
            iconPath: 'assets/images/vendor_icons/Start-Form-Filling.jpg',
            icon: true,
            options: [],
          },
        ],
        selected: false,
        transactionID: 'PROGEN-EXTERNAL-137845',
      },
    ],
  },
};
